(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[684],{

/***/ 5268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3416);
/* harmony import */ var _utils_colors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5963);
/* harmony import */ var _sm_resolver__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(894);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8058);
/* harmony import */ var _hooks_useUpdatePreviewRef__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3053);
/* harmony import */ var _components_LinkWithQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1590);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3446);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5893);
















var ThankYouPage = function ThankYouPage(_ref) {
  var _page$data, _page$data2, _page$data$meta_keywo, _page$data3, _page$data3$meta_keyw, _page$data3$meta_keyw2, _page$data4, _page$data5, _page$data6, _page$data7;

  var page = _ref.page,
      header = _ref.header,
      footer = _ref.footer,
      preview = _ref.preview;
  (0,_hooks_useUpdatePreviewRef__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(preview, page.id);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      firstName = _useState[0],
      setFirstName = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(''),
      textColor = _useState2[0],
      setTextColor = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _localStorage, _localStorage2;

    var name = (0,_utils_common__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .Nw)((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem('formFirstName'));
    var vertical = (0,_utils_common__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .Nw)((_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem('formVertical'));
    setFirstName(name);
    setTextColor((0,_utils_colors__WEBPACK_IMPORTED_MODULE_5__/* .getColor */ .Lq)(vertical).text);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    try {
      setFirstName((0,_utils_common__WEBPACK_IMPORTED_MODULE_7__/* .sanitize */ .Nw)(localStorage.getItem('formFirstName'))); // clear data

      localStorage.removeItem('formFirstName');
      localStorage.removeItem('formVertical');
    } catch (error) {
      setFirstName('');
      _sentry_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .captureException */ .Tb(error);
    }
  }, []);
  var metaTitle = (0,_utils_common__WEBPACK_IMPORTED_MODULE_7__/* .getMetaText */ .pN)((_page$data = page.data) === null || _page$data === void 0 ? void 0 : _page$data.meta_title, page.lang);
  var metaDescription = (0,_utils_common__WEBPACK_IMPORTED_MODULE_7__/* .getMetaText */ .pN)((_page$data2 = page.data) === null || _page$data2 === void 0 ? void 0 : _page$data2.meta_description, page.lang);
  var metaKeywords = (_page$data$meta_keywo = (_page$data3 = page.data) === null || _page$data3 === void 0 ? void 0 : (_page$data3$meta_keyw = _page$data3.meta_keywords) === null || _page$data3$meta_keyw === void 0 ? void 0 : (_page$data3$meta_keyw2 = _page$data3$meta_keyw.map(function (_ref2) {
    var word = _ref2.word;
    return word;
  })) === null || _page$data3$meta_keyw2 === void 0 ? void 0 : _page$data3$meta_keyw2.filter(Boolean)) !== null && _page$data$meta_keywo !== void 0 ? _page$data$meta_keywo : [];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_10__["default"], {
    header: header,
    footer: footer,
    resolver: _sm_resolver__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("title", {
        children: metaTitle
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("meta", {
        property: "og:title",
        content: metaTitle
      }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("meta", {
        name: "description",
        content: metaDescription
      }), !!metaKeywords.length && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("meta", {
        name: "keywords",
        content: metaKeywords.join(', ')
      }), metaKeywords.map(function (word) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("meta", {
          property: "article:tag",
          content: word
        }, (0,nanoid__WEBPACK_IMPORTED_MODULE_12__/* .nanoid */ .x0)());
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "text-center pt-20 pb-16",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("h3", {
        className: "dh-title dark:text-gray-900 uppercase",
        children: (_page$data4 = page.data) === null || _page$data4 === void 0 ? void 0 : _page$data4.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mt-5 text-2xl font-semibold uppercase', "".concat(textColor)),
        children: firstName
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "mt-8 leading-7",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "max-w-xs mx-auto",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__.RichText, {
            render: (_page$data5 = page.data) === null || _page$data5 === void 0 ? void 0 : _page$data5.description
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mt-6 font-semibold text-lg', textColor),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_LinkWithQuery__WEBPACK_IMPORTED_MODULE_9__["default"], {
          href: prismic_reactjs__WEBPACK_IMPORTED_MODULE_1__.Link.url((_page$data6 = page.data) === null || _page$data6 === void 0 ? void 0 : _page$data6.link, _utils_common__WEBPACK_IMPORTED_MODULE_7__/* .prismicLinkResolver */ .LT),
          children: (_page$data7 = page.data) === null || _page$data7 === void 0 ? void 0 : _page$data7.linkLabel
        })
      })]
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ThankYouPage);

/***/ }),

/***/ 2944:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uid]/[verticalid]/[clusterid]/[productid]/[thankyouid]",
      function () {
        return __webpack_require__(5268);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [106,835,909,970,445,446,774,888,179], function() { return __webpack_exec__(2944); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);